import { Component, inject, Input, OnInit } from '@angular/core';

import { EcmMaterialModule } from '@ecm/material';
import { LinkService, TrackingData } from '@ecm/router';

import { DashboardCommercialViewModel } from '../../../business/model/home/dashboard/dashboard-commercial.view-models';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../services/tracking.service';
import { UrlService } from '../../../services/url.service';
import { ImageUtils } from '../../../utils/image.utils';

@Component({
    selector: 'push-commercial',
    templateUrl: './push-commercial.component.html',
    styleUrls: ['./push-commercial.component.scss'],
    standalone: true,
    imports: [EcmMaterialModule],
})
export class PushCommercialComponent implements OnInit {
    public trackingName!: string;
    public isDisabledEclairLink: boolean;

    private readonly linkService = inject(LinkService);
    private readonly trackingService = inject(TrackingService);
    private readonly urlService = inject(UrlService);
    @Input()
    public commercialPush!: DashboardCommercialViewModel;

    @Input()
    public isMobile!: boolean;

    @Input()
    public isSoshBrand!: boolean;

    public ngOnInit(): void {
        if (this.commercialPush) {
            if (this.commercialPush.link) {
                this.commercialPush.href = this.linkService.getLinkSync(this.commercialPush.link);
            }
            this.trackingName = this.trackingService.getTrackNamePerCategorie(
                this.commercialPush.category,
                this.isMobile,
                this.isSoshBrand,
            );
            if (this.commercialPush.link) {
                this.isDisabledEclairLink = this.urlService.isDisabledEclairLink(this.commercialPush.link);
            }
        }
    }

    public openLink(commercialPush: DashboardCommercialViewModel) {
        this.linkService.openLink(
            commercialPush.link,
            Object.assign(new TrackingData(), {
                cappingTracking:
                    commercialPush.advTracker && commercialPush.advTracker.length > 0
                        ? {
                              advTracker: commercialPush.advTracker,
                              code: commercialPush.code,
                              cid: commercialPush.cid,
                          }
                        : null,
                tmsTracking: {
                    trackedPage: TrackedPage.dashboard,
                    trackingArea: this.commercialPush.trackingData.tmsTracking.trackingArea,
                    trackingName: commercialPush.code,
                },
            }),
        );
    }

    public getImgFormat(imageurl: string) {
        return ImageUtils.transformUrl(imageurl, '100');
    }
}
